import React from 'react';
import PropTypes from 'prop-types';
import TextInput from '../formComponents/TextInput';
import translator from '../../translations/drupalTranslator';
import CustomerContactInfoPhoneCode from './CustomerContactInfoPhoneCode';
import Translate from '../Translate';

const CustomerContactInfoComp = (props) => {
  const getFormFieldClassName = (name, obj = props.errors) => {
    const className = 'form-field';
    if (obj[props.name] && obj[props.name].length) {
      return `${className} form-field--error`;
    }
    return className;
  };

  const validator = (data) => {
    props.validate(data)
      .then(([innerValidator, innerData]) => innerValidator(innerData),
        () => true)
      .catch(() => true);
  };

  const translateDescription = props.description ?
    (
<Translate
  className="form-field__description"
  component="span"
  content={props.description}
/>
    ) : null;

  let error = null;
  if (props.errors[props.name] && props.errorMessages[props.errors[props.name]]) {
    error = translator.translate(props.errorMessages[props.errors[props.name]]);
  }

  const getProps = () => {
    /* eslint-disable no-unused-vars */
    const {
      errors,
      requiredFields,
      errorMessages,
      description,
      name,
      // We need htmlAttrName to be able to put different
      // value to html but keep proper key for react internals.
      // @see CustomContactInfoStreetNumber
      htmlAttrName,
      values,
      ...properties
    } = props;
    /* eslint-enable no-unused-vars */
    properties.showError = props.rootClass !== 'phone-input' && error !== null;
    properties.className = 'text-input';
    properties.errorText = error;
    properties.required = !!props.requiredFields.find(field => field === props.name);
    properties.validate = validator;
    if (properties.placeholder) {
      properties.placeholder = translator.translate(props.placeholder);
    }
    if (values && values[props.name]) {
      properties.value = values[props.name];
    }
    return properties;
  };

  const handleNumberKeyPress = (event) => {
    if (!/[0-9]/.test(event.key)) {
      event.preventDefault();
    }
  }

  if (props.name === 'phoneNumber') {
    return (
      <div className={getFormFieldClassName(props.name)} key={props.name}>
        <label className="form-label" htmlFor={props.name}>
          <Translate content={props.label} />
          {getProps().required ? <span> &#42;</span> : null }
        </label>
        <div className="form-field__phone-number-wrapper">
          <CustomerContactInfoPhoneCode {...props}  order={props.order} />
          <TextInput
            id={props.name}
            name={props.htmlAttrName || props.name}
            onClick={() => props.interactCustomerInfo()}
            onKeyPress={(event) => handleNumberKeyPress(event)}
            debounceValue={1500}
            {...getProps()}
          />
        </div>
        {translateDescription}
      </div>
    );
  }
  return (
    <div className={getFormFieldClassName(props.name)} key={props.name}>
      <label className="form-label" htmlFor={props.name}>
        <Translate content={props.label} />
        {getProps().required ? <span> &#42;</span> : null }
      </label>
      <TextInput
        id={props.name}
        name={props.htmlAttrName || props.name}
        onClick={() => props.interactCustomerInfo()}
        {...getProps()}
      />
      {translateDescription}
    </div>
  );
};

CustomerContactInfoComp.defaultProps = {
  rootClass: 'form-input',
};

CustomerContactInfoComp.PropTypes = {
  description:PropTypes.string,
  errors:PropTypes.object,
  name:PropTypes.string.isRequired,
  htmlAttrName:PropTypes.string,
  requiredFields:PropTypes.array.isRequired,
  onChange:PropTypes.func.isRequired,
  validate:PropTypes.func.isRequired,
  label:PropTypes.string.isRequired,
  placeholder:PropTypes.string,
  errorMessages:PropTypes.shape({
    field_is_required:PropTypes.string,
    field_is_invalid:PropTypes.string,
  }),
  rootClass:PropTypes.string.isRequired,
  interactCustomerInfo:PropTypes.func,
  values:PropTypes.object,
};

export default CustomerContactInfoComp;
